<template>
  <div class="footer_box">
    <div class="pc">
      <div></div>
      <div class="pc_content">
        <div class="item">
          <p class="title">联系电话</p>
          <div class="contact_methods">
            <p>客服电话：0755-23502423</p>
            <p>客服邮箱：customerservice@cozy-time.com</p>
          </div>
          <p>
            <span style="color:#dddddd;">商务合作：</span>
            <span style="color:#dc822e">f_luo@cozy-time.com</span>
          </p>
        </div>
        <div class="item">
          <p class="title">联系地址</p>
          <div class="contact_methods">
            <p>深圳市宝安区福永街道福洲大道福永意库6栋B座206室</p>
            <p>地铁11号福永站D出口，步行200米左右</p>
          </div>
        </div>
        <div class="item">
          <p class="title">关注我们</p>
          <div class="img_box">
            <img src="../../../../assets/newImages/bottom/0009.png">
            <img src="../../../../assets/newImages/bottom/mini.jpg" alt="">
          </div>
        </div>
      </div>
      <div></div>
      <div class="copy_right">
        <center>
          <img src="../../../../assets/newWebSiteImg/pc/home/bottom_logo.png" style="height: 55px;">
          <div style="color: #dddddd;margin-top: 10px;display: flex;justify-content: center;align-items: center;">
            <span>copyright © 2019-{{ year }} 深圳市科坦科技有限公司 版权所有</span>
            <a class="a_link" target="_blank" href="https://beian.miit.gov.cn" style="color: #dddddd;">粤ICP备20000912号</a>
            <img src="@/assets/img/bei-an.png" alt="" style="width: 15px;height: 15px;">
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030602005118"
              style="display: inline-block; text-decoration: none;margin-left: 3px;color: #dddddd;">
              粤公网安备 44030602005118号
            </a>
          </div>
        </center>
      </div>
    </div>

    <div class="app">

    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style scoped lang="less">
.footer_box {
  background-color: #565555;

  // pc
  @media screen and (min-width: 992px) {
    .pc {
      display: block;
      display: grid;
      grid-template-columns: auto 1401px auto;

      .pc_content {
        padding: 30px 0;
        display: grid;
        grid-template-columns: repeat(3, auto);
        grid-column-gap: 40px;

        .item {
          .title {
            font-size: 18px;
            color: #fff;
            border-bottom: 1px solid #656464;
            padding-bottom: 20px;
            margin-bottom: 30px;
          }

          .contact_methods {
            display: grid;
            grid-template-rows: repeat(2, 25px);
            align-items: center;
            color: #dddddd;
            margin-bottom: 30px;
          }

          .img_box {
            display: grid;
            grid-template-columns: repeat(2, 144px);
            grid-column-gap: 67px;

            img {
              width: 144px;
              height: 144px;
            }
          }
        }
      }

      .copy_right {
        grid-column-start: 1;
        grid-column-end: 4;
        min-height: 100px;
        padding: 10px 0;
        border-top: 1px solid #656464;

        .a_link::before,
        .a_link::after {
          content: '|';
          margin: 0 3px;
        }
      }
    }

    .app {
      display: none;
    }

  }

  @media screen and (max-width: 992px) {
    .pc {
      display: none;
    }

    .app {
      display: block;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/newWebsite/main/components/Footer.vue